import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  ListTriggersResponse,
  listTriggers as universalListTriggers,
} from './ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/ecom' };

export function listTriggers(httpClient: HttpClient): ListTriggersSignature {
  return () =>
    universalListTriggers(
      // @ts-ignore
      { httpClient }
    );
}

interface ListTriggersSignature {
  /**
   * List all custom triggers that are available on a given site
   */
  (): Promise<
    NonNullablePaths<
      ListTriggersResponse,
      | `triggers`
      | `triggers.${number}._id`
      | `triggers.${number}.appId`
      | `triggers.${number}.name`,
      4
    >
  >;
}

export {
  Address,
  CatalogReference,
  CustomTrigger,
  EligibleTrigger,
  GetEligibleTriggersRequest,
  GetEligibleTriggersResponse,
  LineItem,
  ListTriggersRequest,
  ListTriggersResponse,
  ListTriggersResponseCustomTrigger,
  ShippingInfo,
  TriggerToFilterBy,
} from './ecom-custom-trigger-v1-custom-trigger-discounts-custom-trigger.universal.js';
